var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mailvelope)?_c('div',{attrs:{"id":"mail-content"}}):_c('span',[_vm._v(_vm._s(_vm.t('mail', 'This message is encrypted with PGP. Install Mailvelope to decrypt it.')))])])}
var staticRenderFns = []

export { render, staticRenderFns }